import {EventEmitter, Injectable, Output} from '@angular/core';

@Injectable()
export class BreadcumbsService {
  @Output() setSubfolder = new EventEmitter<string>();

  constructor() { }

}
